import type { ObjectId } from "@bbj-types/utils";

export enum WsReadyState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}
export interface IWsSocket {
  readonly readyState: WsReadyState;
  onopen: ((ev: Event) => void) | null;
  onmessage: ((ev: MessageEvent) => void) | null;
  onclose: ((ev: CloseEvent) => void) | null;
  onerror: ((ev: Event) => void) | null;

  send(data: string): void;
  close(code?: number, reason?: string): void;
}
export type TWsSocketFactory = (url: string) => IWsSocket;

export type TReconnectConfig = {
  baseDelayMs: number;
  maxDelayMs: number;
  jitterRatio: number;
  maxAttempts: number;
};

export type TWebsocketClientParams = {
  userId: ObjectId;
  url?: string;
};

export type TWebsocketClientOptions = {
  onStateChange?: (from: string, to: string) => void;
  onMessage?: (ev: MessageEvent) => void;
  reconnect?: Partial<TReconnectConfig>;
  outboxMax?: number;
  clock?: IWsClock;
  visibility?: IWsVisibility;
  backoff?: TWsBackoffStrategy;
  socketFactory?: TWsSocketFactory;
  timings?: {
    heartbeatMs?: number;
    inactivityMs?: number;
  };
  shouldConnect?: () => boolean;
};

export enum WebsocketStateCode {
  NORMAL_CLOSURE = 1000,
  GOING_AWAY = 1001,
  ABNORMAL_CLOSURE = 1006,
  POLICY_VIOLATION = 1008,
  INACTIVITY_TIMEOUT = 4001,
}

export interface IWsClock {
  setTimeout(fn: () => void, ms?: number | undefined): number;
  clearTimeout(id: number): void;
  setInterval(fn: () => void, ms?: number | undefined): number;
  clearInterval(id: number): void;
  now(): number;
}

export type IWsVisibility = {
  isHidden(): boolean;
  onChange(cb: () => void): () => void; // returns unsubscribe
};

export type TWsBackoffStrategy = (attempt: number) => number;
